import React from "react";
import Field from "./Field";
import EmailControl from "./EmailControl";
import { FieldProps } from "./Types";

const EmailField: React.FC<FieldProps> = ({ labelProps, controlProps, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <EmailControl {...controlProps} disabled={disabled} />
        </Field>
    );
}
export default EmailField;